import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SelectAll = ({
    hide=false,
    onSelectAll
  }) => {
  
    const [hidden, setHide] = useState(hide) 
    useEffect(()=> {
      if(hidden){
        setHide(true)
      }
    })

    const selectAllClass = () => classNames({
      'px-2.5 py-2 text-sm text-action-blue font-medium-font': true,
      hidden: hide,
    });

    if (hidden) {
      return null;
    }

    return (
      <div data-testid="select-all" className={selectAllClass()}>
        <a
          onClick={onSelectAll}
          role="button"
          tabIndex={0}
        >
          Select All
        </a>
      </div>
    );
  
}

SelectAll.propTypes = {
  hide: PropTypes.bool,
  onSelectAll: PropTypes.func.isRequired,
};

export default SelectAll;
